import { render, staticRenderFns } from "./shopPurchaseEdit.vue?vue&type=template&id=52ba75a9&scoped=true&"
import script from "./shopPurchaseEdit.vue?vue&type=script&lang=js&"
export * from "./shopPurchaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./shopPurchaseEdit.vue?vue&type=style&index=0&id=52ba75a9&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba75a9",
  null
  
)

export default component.exports